import {fabric} from 'fabric';
import {renderIcon} from '~/common/canvas/renderIcon';
import RotationIcon from '~library/svg/icons/RotationIcon.svg';
import {white} from '~libSass/base/_exports.sass';

export const rotationControl = () =>
  new fabric.Control({
    x: 0,
    y: 0.5,
    offsetX: 0,
    offsetY: 20,
    cornerSize: 12,
    touchSizeX: 24,
    touchSizeY: 24,
    withConnection: false,
    actionName: 'rotate',
    cursorStyle: 'pointer',
    render: renderIcon({icon: RotationIcon, padding: 4, fillStyle: white}),
    actionHandler: fabric.controlsUtils.rotationWithSnapping,
  });
